// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__29TzG","modalForm":"UpgradeEpcsModal_modalForm__3GmFh","modalFooter":"UpgradeEpcsModal_modalFooter__1fNwg"};